import Sidecntp from './Sidecntp'
import './sidenav.css'
import { NavLink } from 'react-router-dom'
import { ReactComponent as Profile } from '../../icons/user-solid.svg';
import { ReactComponent as Work } from '../../icons/laptop-file-solid.svg';
import { ReactComponent as Contact } from '../../icons/address-book-solid.svg';
// import { ReactComponent as Usergraduated } from '../../icons/user-graduate-solid.svg';
import { ReactComponent as Brain } from '../../icons/brain-solid.svg';

export default function Sidenav() {
  return (
    <div className='sidenav bor'>
      <NavLink className='nav-link' to="/">
        <Sidecntp name="Profile" bgcolor="rgb(58, 57, 57)" componentToPassDown={<Profile fill="#ffffff"/>}/>
      </NavLink>
      <NavLink className='nav-link' to="work">
        <Sidecntp name="My Works" bgcolor="rgb(58, 57, 57)" componentToPassDown={<Work fill="#ffffff"/>}/>
      </NavLink>
      {/* <NavLink className='nav-link' to="education">
        <Sidecntp name="Education" bgcolor="rgb(58, 57, 57)" componentToPassDown={<Usergraduated fill="#ffffff"/>}/>
      </NavLink> */}
      <NavLink className='nav-link' to="skills">
        <Sidecntp name="Skills" bgcolor="rgb(58, 57, 57)" componentToPassDown={<Brain fill="#ffffff"/>}/>
      </NavLink>
      <NavLink className='nav-link' to="contact">
        <Sidecntp name="Contact" bgcolor="rgb(58, 57, 57)" componentToPassDown={<Contact fill="#ffffff"/>}/>
      </NavLink>
    </div>
  )
}
